import React from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import DesignHero from "../../assets/Design-Hero.jpg";
import ExpertiseImage from "../../assets/Design-Expertise.jpg";
import ModularApproach from "../../assets/ModularApproach.jpg";
import ManufacturerDesign from "../../assets/ManufacturingImage.jpg";
import IntellectualProperty from "../../assets/Intellectual.jpg";
import PrototypeImage from "../../assets/Prototype-image.jpg";
import MedicalPrototype from "../../assets/medicaldevice-proto.jpg";
import MedicalDevelopment from "../../assets/wedevelop.jpg";
import SixDevelopment from "../../assets/sixDevelopment.jpg";

const Design = () => {
  const handleTalkToTeam = () => {
    window.location.href = "/contact-us";
  };

  const handleGetInTouch = () => {
    window.location.href = "/contact-us";
  };

  return (
    <>
      <Helmet>
        <title>Medichy | Medical Device Design</title>
        <meta
          name="description"
          content="Medichy offers comprehensive medical device design services with expertise in minimally invasive devices, catheter technologies, and regulatory compliance."
        />
      </Helmet>
      <TheDesignSection>
        <div className="contact-hero-section">
          <img src={DesignHero} alt="page banner" />
          <div className="overlay"></div>
          <div className="hero-content">
            <h3>
              Transforming medical device concepts into manufacturable realities
            </h3>
            <p>
              Our expert design team combines medical expertise with engineering
              precision to deliver innovative, compliant, and scalable medical
              device solutions.
            </p>
            <button className="btn-secondary" onClick={handleTalkToTeam}>
              TALK TO OUR DESIGN TEAM
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                />
              </svg>
            </button>
          </div>
        </div>

        <div className="container">
          <div className="medical-device">
            <div className="section-header">
              <h3>Medical Device Design Expertise</h3>
              <p className="section-subtitle">
                Move your product development project forward with our
                comprehensive medical device design services. We offer a
                complete product design and development service with an
                experienced team of designers who can take your ideas from
                concept stage to finished product ready for scale-up
                manufacturing.
              </p>
              <p className="section-description">
                Using our minimally invasive medical device design experience,
                we have developed a{" "}
                <a href="#six-designs" className="highlight-link">
                  Six-Step Medical Device Product Design Process
                </a>
                . Our proven method takes a holistic approach to the idea you
                have, developing it as a complete project, not just a product.
              </p>
            </div>
          </div>

          <div className="design-expertise">
            <div className="expertise-container">
              <div className="expertise-content">
                <h4>Medical Device Design Specialties</h4>
                <div className="expertise-list">
                  <div className="expertise-category">
                    <h5>Core Expertise</h5>
                    <ul>
                      <li>
                        <a href="/expertise/minimally-invasive">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                            <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                          </svg>
                          Minimally invasive medical devices
                        </a>
                      </li>
                      <li>
                        <a href="/expertise/catheter-technologies">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                            <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                          </svg>
                          Advanced catheter technologies
                        </a>
                      </li>
                      <li>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                          <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                        </svg>
                        Interventional catheters
                      </li>
                      <li>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                          <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                        </svg>
                        Diagnostic catheters
                      </li>
                    </ul>
                  </div>

                  <div className="expertise-category">
                    <h5>Device Components</h5>
                    <ul>
                      <li>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                          <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                        </svg>
                        Access devices
                      </li>
                      <li>
                        <a href="/expertise/guidewires">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                            <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                          </svg>
                          Guidewires
                        </a>
                      </li>
                      <li>
                        <a href="/expertise/needles-cannulas-stylets">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                            <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                          </svg>
                          Specialty medical needles, stylets, and cannulas
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="expertise-image">
                <img src={ExpertiseImage} alt="expertiseImage" />
                <div className="image-overlay-card"></div>
              </div>
            </div>
          </div>

          <div className="modular-approach">
            <div className="modular-container">
              <div className="modular-image">
                <img src={ModularApproach} alt="modularImg" />
                <div className="image-overlay-card"></div>
              </div>

              <div className="modular-content">
                <div className="content-header">
                  <div className="icon-wrapper">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5 8 5.961 14.154 3.5 8.186 1.113zM15 4.239l-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923l6.5 2.6zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464L7.443.184z" />
                    </svg>
                  </div>
                  <h4>Modular Approach to Medical Device Product Design</h4>
                </div>
                <p>
                  Our modular approach can align with your requirements,
                  supporting your medical device development project at any
                  stage from initial concept generation to scale-up
                  manufacturing. We provide flexible engagement models that
                  adapt to your project needs and timeline.
                </p>
                <div className="modular-features">
                  <div className="feature">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                    </svg>
                    <span>Flexible project engagement models</span>
                  </div>
                  <div className="feature">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                    </svg>
                    <span>Stage-specific support and deliverables</span>
                  </div>
                  <div className="feature">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                    </svg>
                    <span>Scalable team integration</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="design-manufacturer">
            <div className="manufacturer-container">
              <div className="manufacturer-content">
                <div className="content-header">
                  <div className="icon-wrapper">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path d="M9.5 0a.5.5 0 0 1 .5.5.5.5 0 0 0 .5.5.5.5 0 0 1 .5.5V2a.5.5 0 0 1-.5.5h-5A.5.5 0 0 1 5 2v-.5a.5.5 0 0 1 .5-.5.5.5 0 0 0 .5-.5.5.5 0 0 1 .5-.5h3Z" />
                      <path d="M3 2.5a.5.5 0 0 1 .5-.5H4a.5.5 0 0 0 0-1h-.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v12A1.5 1.5 0 0 0 12.5 1H12a.5.5 0 0 0 0 1h.5a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-12Z" />
                      <path d="M10.854 7.854a.5.5 0 0 0-.708-.708L7.5 9.793 6.354 8.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3Z" />
                    </svg>
                  </div>
                  <h4>Design for Manufacturing and Assembly</h4>
                </div>
                <p className="manufacturer-description">
                  Medichy understands the importance of creating devices that
                  are suitable from both functional and manufacturing
                  perspectives. We support builds for concept development and
                  product builds for pre-clinical and clinical requirements,
                  aiming to turn around functional prototypes as quickly as
                  possible.
                </p>

                <div className="manufacturer-details">
                  <p>
                    Throughout this phase, we apply Design for Manufacture (DFM)
                    techniques and offer suggestions for design changes. By
                    implementing these changes during the design phase, we can
                    meet your target manufacturing costs. DFM provides
                    significant benefits:
                  </p>

                  <div className="benefits-grid">
                    <div className="benefit-item">
                      <div className="benefit-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z" />
                          <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z" />
                        </svg>
                      </div>
                      <span>Higher quality products</span>
                    </div>

                    <div className="benefit-item">
                      <div className="benefit-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z" />
                          <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z" />
                        </svg>
                      </div>
                      <span>Reliable manufacturing processes</span>
                    </div>

                    <div className="benefit-item">
                      <div className="benefit-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z" />
                          <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z" />
                        </svg>
                      </div>
                      <span>Simplified assembly processes</span>
                    </div>

                    <div className="benefit-item">
                      <div className="benefit-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z" />
                          <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z" />
                        </svg>
                      </div>
                      <span>Regulatory requirement adherence</span>
                    </div>

                    <div className="benefit-item">
                      <div className="benefit-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z" />
                          <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z" />
                        </svg>
                      </div>
                      <span>Accelerated time to market</span>
                    </div>
                  </div>

                  <div className="contact-info">
                    <p>
                      <strong>Contact us:</strong> Email sales@medichy.com or
                      phone +353 71 91 15111
                    </p>
                    <p>
                      You can also complete the contact form on this page, and a
                      member of our team will get back to you.
                    </p>
                  </div>
                </div>
              </div>

              <div className="manufacturer-image">
                <img src={ManufacturerDesign} alt="manufacturingImg" />
                <div className="image-overlay-card"></div>
              </div>
            </div>
          </div>

          <div className="intellectual-property">
            <div className="intellectual-container">
              <div className="intellectual-content">
                <div className="content-header">
                  <div className="icon-wrapper">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8.5 2.687c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492V2.687zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783z" />
                    </svg>
                  </div>
                  <h4>Intellectual Property Protection</h4>
                </div>
                <p className="intellectual-description">
                  The ownership of intellectual property is of the utmost
                  importance. When you partner with Medichy, all intellectual
                  property related to your medical device product remains yours.
                </p>
                <div className="ip-features">
                  <div className="ip-feature">
                    <div className="ip-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z" />
                      </svg>
                    </div>
                    <div className="ip-text">
                      <h5>100% IP Ownership</h5>
                      <p>All intellectual property remains with you</p>
                    </div>
                  </div>

                  <div className="ip-feature">
                    <div className="ip-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                      </svg>
                    </div>
                    <div className="ip-text">
                      <h5>Complete Confidentiality</h5>
                      <p>Strict NDA and confidentiality agreements</p>
                    </div>
                  </div>

                  <div className="ip-feature">
                    <div className="ip-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z" />
                        <path d="M7 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708L3.854 7.5l1.646 1.646a.5.5 0 0 1-.708.708l-2-2a.5.5 0 0 1 0-.708l2-2a.5.5 0 0 1 .708 0z" />
                      </svg>
                    </div>
                    <div className="ip-text">
                      <h5>Transparent Documentation</h5>
                      <p>Clear IP assignment and documentation</p>
                    </div>
                  </div>
                </div>

                <p className="ip-note">
                  Please contact us if you have any queries regarding
                  intellectual property protection or confidentiality
                  agreements.
                </p>
              </div>

              <div className="intellectual-image">
                <img src={IntellectualProperty} alt="intellectualImg" />
                <div className="image-overlay-card"></div>
              </div>
            </div>
          </div>

          <div className="prototype-medical">
            <h4>Medical Device Prototyping Capabilities</h4>
            <p>
              During the medical device design process, the prototyping stages
              are essential. The prototyping stages improve the product,
              identify risks, and reduce overall development time. They are also
              typically required to get regulatory approval. At Medichy, we have
              in-house prototyping capabilities. The fact they are in-house
              improves turnaround times, speeds up the design process, and
              enhances quality. We develop medical device prototypes as part of
              the concept development process as well as prototypes for later
              stages of your medical device's lifecycle, including prototypes
              for pre-clinical and clinical requirements. To find out more about
              our prototyping capabilities at Medichy, or to speak to one of our
              engineers about your idea for a new medical device, please contact
              us today. Complete the form on this page and a member of our team
              will get back to you.
            </p>
          </div>

          <div className="prototype-importance">
            <div className="prototype-writeUps">
              <h4>The Importance of Medical Device Prototyping</h4>
              <p>
                Designing a new medical device product is an iterative process,
                and creating prototypes is an essential element. The advantages
                of prototypes include:
              </p>

              <ul>
                <li>
                  Helps confirm the product can perform the task it is being
                  created for.
                </li>
                <li>
                  Ensures the performance of the product is to an acceptable
                  standard.
                </li>
                <li>
                  Helps with the process of ensuring the product meets the
                  requirements of regulators.
                </li>
                <li>
                  Your new medical device product has to be commercially viable
                  too.
                </li>
                <li>
                  Prototyping is essential in this regard as it provides crucial
                  information on the practicalities and cost-effectiveness of
                  manufacturing the product at scale.
                </li>
              </ul>
              <p>
                Finally, there are often improvements, enhancements, and changes
                that only become apparent when you can physically hold, inspect,
                and try the medical device. Prototyping lets you do this.
              </p>
            </div>
            <div className="prototype">
              <img src={PrototypeImage} alt="prototypeImage" />
            </div>
          </div>

          <div className="medical-prototype">
            <div className="medical-prototype-writeUps">
              <h4>Medical Device Prototype Manufacturing</h4>
              <p>
                As an experienced medical device design manufacturer, we have
                state of the art medical device prototyping facilities at
                Medichy. This is in addition to industry-leading engineering and
                manufacturing expertise. The in-house medical device
                manufacturing capabilities we can use to create a prototype of
                your new product include 3D printing, balloon blowing, laser
                welding, bonding, injection moulding, and more.
              </p>
            </div>
            <div className="medical-prototype-image">
              <img src={MedicalPrototype} alt="medicalPrototypeImage" />
            </div>
          </div>

          <div className="prototype-development">
            <div className="prototype-development-image">
              <img src={MedicalDevelopment} alt="medicalPrototypeImage" />
            </div>
            <div className="prototype-development-writeUps">
              <h4>Prototypes We Develop</h4>
              <p>
                While all medical device design projects are different, we do
                follow a structured, tried and tested process. This process
                includes two main prototyping stages:
              </p>
              <ul>
                <li>
                  Prototype 1 – a prototype produced following the creation of
                  initial design drawings.
                </li>
                <li>
                  Prototype 2 – a validated and regulatory-compliant prototype
                  that you can use for evaluation and testing.
                </li>
              </ul>
            </div>
          </div>

          <div className="six-development" id="six-designs">
            <div className="six-development-image">
              <img src={SixDevelopment} alt="sixDevelopmentImage" />
            </div>
            <div className="six-write-ups">
              <h4>
                Medical Device Design Process - Concept to Finished Product
              </h4>
              <p>
                Our well-established Six-Step Medical Device Design Process will
                advance your product idea through all the necessary stages to
                produce a finished product ready for testing and further
                evaluation. Our process produces high-quality prototypes that
                performs according to their functional requirements. We also
                take into account regulatory considerations, design for
                manufacture (DFM) principles, and commercialization objectives.
              </p>
              <p>The steps in our Six-Step Medical Design Process include:</p>
              <ul>
                <li>
                  Requirement stage – define user requirements, functional
                  requirements, specifications, project goals, and targets.
                </li>
                <li>
                  Concept stage – group ideation to create multiple concepts and
                  solutions for evaluation.
                </li>
                <li>
                  Development stage – select a preferred design, create a 3D
                  model, and review manufacturing methods and materials.
                </li>
                <li>
                  1st prototype stage – produce physical models of the device
                  for bench testing, evaluation, and review of size, fit, and
                  ergonomics.
                </li>
                <li>
                  Refinement stage – select a design and review design for
                  manufacture and design for assembly considerations.
                </li>
                <li>
                  2nd prototype stage – fabricate a high-quality prototype based
                  on the refined design.
                </li>
              </ul>
            </div>
          </div>

          <div className="cta-section">
            <div className="cta-content">
              <h3>Start Your Medical Device Design Journey</h3>
              <p>
                Partner with our expert design team to transform your concept
                into a manufacturable reality.
              </p>
              <button className="btn-primary" onClick={handleGetInTouch}>
                GET IN TOUCH
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </TheDesignSection>
    </>
  );
};

const TheDesignSection = styled.div`
  width: 100%;
  min-height: 100vh;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 2rem;
  }

  .contact-hero-section {
    position: relative;
    height: 70vh;
    width: 100%;
    overflow: hidden;
    margin-bottom: 4rem;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        135deg,
        rgba(0, 100, 200, 0.85) 0%,
        rgba(0, 50, 150, 0.9) 100%
      );
    }
    .hero-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      color: #fff;
      width: 90%;
      max-width: 900px;
      padding: 0 1rem;

      h3 {
        font-size: 2.5rem;
        font-weight: 700;
        margin-bottom: 1.5rem;
        text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);
        line-height: 1;
      }

      p {
        font-size: 1rem;
        font-weight: 400;
        opacity: 0.95;
        text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
        margin-bottom: 2rem;
        line-height: 1.6;
        max-width: 700px;
        margin-left: auto;
        margin-right: auto;
      }

      .btn-secondary {
        display: inline-flex;
        align-items: center;
        gap: 0.75rem;
        background: transparent;
        color: white;
        border: 2px solid white;
        padding: 1rem 2.5rem;
        font-size: 1.1rem;
        font-weight: 600;
        border-radius: 50px;
        cursor: pointer;
        transition: all 0.3s ease;
        text-transform: uppercase;
        letter-spacing: 0.5px;

        &:hover {
          background: white;
          color: #3182ce;
          transform: translateY(-2px);
          box-shadow: 0 4px 15px rgba(255, 255, 255, 0.2);

          svg {
            transform: translateX(5px);
          }
        }

        svg {
          transition: transform 0.3s ease;
        }
      }
    }
  }

  .section-header {
    text-align: center;
    margin-bottom: 4rem;

    h3 {
      font-size: 2.5rem;
      font-weight: 700;
      color: #1a1a1a;
      margin-bottom: 1rem;
    }

    .section-subtitle {
      font-size: 1.25rem;
      color: #666;
      line-height: 1.6;
      max-width: 800px;
      margin: 0 auto 1.5rem;
    }

    .section-description {
      font-size: 1.1rem;
      color: #666;
      line-height: 1.6;
      max-width: 800px;
      margin: 0 auto;

      .highlight-link {
        color: #3182ce;
        font-weight: 600;
        text-decoration: none;
        border-bottom: 2px solid transparent;
        transition: all 0.3s ease;

        &:hover {
          border-bottom-color: #3182ce;
        }
      }
    }
  }

  /* New: Prototype Medical Section */
  .prototype-medical {
    padding: 4rem 0;
    text-align: center;

    h4 {
      font-size: 2rem;
      font-weight: 700;
      color: #1a1a1a;
      margin-bottom: 2rem;
      position: relative;
      display: inline-block;

      &:after {
        content: "";
        position: absolute;
        bottom: -10px;
        left: 50%;
        transform: translateX(-50%);
        width: 60px;
        height: 4px;
        background: linear-gradient(135deg, #3182ce, #2c5282);
        border-radius: 2px;
      }
    }

    p {
      font-size: 1.1rem;
      color: #666;
      line-height: 1.8;
      max-width: 900px;
      margin: 0 auto;
      text-align: left;
    }
  }

  /* New: Prototype Importance Section */
  .prototype-importance {
    padding: 4rem 0;
    background: #f8fafc;
    border-radius: 24px;
    margin: 4rem 0;

    .prototype-writeUps {
      margin-bottom: 3rem;

      h4 {
        font-size: 2rem;
        font-weight: 700;
        color: #1a1a1a;
        margin-bottom: 1.5rem;
        position: relative;
        display: inline-block;

        &:after {
          content: "";
          position: absolute;
          bottom: -8px;
          left: 0;
          width: 60px;
          height: 4px;
          background: linear-gradient(135deg, #3182ce, #2c5282);
          border-radius: 2px;
        }
      }

      > p {
        font-size: 1.1rem;
        color: #666;
        line-height: 1.6;
        margin-bottom: 1.5rem;
      }

      ul {
        list-style: none;
        padding: 0;
        margin: 1.5rem 0 2rem;

        li {
          display: flex;
          align-items: flex-start;
          gap: 0.75rem;
          margin-bottom: 0.75rem;
          color: #4a5568;
          font-size: 1rem;
          line-height: 1.5;

          &:before {
            content: "";
            width: 24px;
            height: 24px;
            background: linear-gradient(135deg, #3182ce, #2c5282);
            border-radius: 50%;
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
          }

          &:after {
            content: "✓";
            position: absolute;
            color: white;
            font-size: 0.75rem;
            font-weight: bold;
            margin-left: 8px;
            margin-top: 4px;
          }
        }
      }

      > p:last-of-type {
        font-size: 1rem;
        color: #4a5568;
        line-height: 1.6;
      }
    }

    .prototype {
      position: relative;
      border-radius: 16px;
      overflow: hidden;
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
      height: 350px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.5s ease;
      }

      &:hover img {
        transform: scale(1.05);
      }
    }
  }

  /* New: Medical Prototype Section */
  .medical-prototype {
    padding: 4rem 0;

    .medical-prototype-writeUps {
      margin-bottom: 3rem;

      h4 {
        font-size: 2rem;
        font-weight: 700;
        color: #1a1a1a;
        margin-bottom: 1.5rem;
        position: relative;
        display: inline-block;

        &:after {
          content: "";
          position: absolute;
          bottom: -8px;
          left: 0;
          width: 60px;
          height: 4px;
          background: linear-gradient(135deg, #3182ce, #2c5282);
          border-radius: 2px;
        }
      }

      p {
        font-size: 1.1rem;
        color: #666;
        line-height: 1.6;
      }
    }

    .medical-prototype-image {
      position: relative;
      border-radius: 16px;
      overflow: hidden;
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
      height: 400px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.5s ease;
      }

      &:hover img {
        transform: scale(1.05);
      }
    }
  }

  /* New: Prototype Development Section */
  .prototype-development {
    padding: 4rem 0;
    background: #f8fafc;
    border-radius: 24px;
    margin: 4rem 0;

    .prototype-development-image {
      position: relative;
      border-radius: 16px;
      overflow: hidden;
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
      height: 350px;
      margin-bottom: 3rem;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.5s ease;
      }

      &:hover img {
        transform: scale(1.05);
      }
    }

    .prototype-development-writeUps {
      h4 {
        font-size: 2rem;
        font-weight: 700;
        color: #1a1a1a;
        margin-bottom: 1.5rem;
        position: relative;
        display: inline-block;

        &:after {
          content: "";
          position: absolute;
          bottom: -8px;
          left: 0;
          width: 60px;
          height: 4px;
          background: linear-gradient(135deg, #3182ce, #2c5282);
          border-radius: 2px;
        }
      }

      p {
        font-size: 1.1rem;
        color: #666;
        line-height: 1.6;
        margin-bottom: 1.5rem;
      }

      ul {
        list-style: none;
        padding: 0;

        li {
          display: flex;
          align-items: flex-start;
          gap: 0.75rem;
          margin-bottom: 0.75rem;
          color: #4a5568;
          font-size: 1rem;
          line-height: 1.5;

          &:before {
            content: "";
            width: 20px;
            height: 20px;
            background: linear-gradient(135deg, #3182ce, #2c5282);
            border-radius: 4px;
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
          }

          &:after {
            content: "→";
            position: absolute;
            color: white;
            font-size: 0.75rem;
            font-weight: bold;
          }
        }
      }
    }
  }

  /* New: Six Development Section */
  .six-development {
    padding: 4rem 0;

    .six-development-image {
      position: relative;
      border-radius: 16px;
      overflow: hidden;
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
      height: 400px;
      margin-bottom: 3rem;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        transition: transform 0.5s ease;
      }

      &:hover img {
        transform: scale(1.05);
      }
    }

    .six-write-ups {
      h4 {
        font-size: 2rem;
        font-weight: 700;
        color: #1a1a1a;
        margin-bottom: 1.5rem;
        position: relative;
        display: inline-block;

        &:after {
          content: "";
          position: absolute;
          bottom: -8px;
          left: 0;
          width: 60px;
          height: 4px;
          background: linear-gradient(135deg, #3182ce, #2c5282);
          border-radius: 2px;
        }
      }

      > p {
        font-size: 1.1rem;
        color: #666;
        line-height: 1.6;
        margin-bottom: 1.5rem;
      }

      ul {
        list-style: none;
        padding: 0;

        li {
          display: flex;
          align-items: flex-start;
          gap: 0.75rem;
          margin-bottom: 0.75rem;
          color: #4a5568;
          font-size: 1rem;
          line-height: 1.5;
          position: relative;
          padding-left: 2rem;

          &:before {
            content: counter(item);
            counter-increment: item;
            position: absolute;
            left: 0;
            top: 0;
            width: 24px;
            height: 24px;
            background: linear-gradient(135deg, #3182ce, #2c5282);
            border-radius: 50%;
            color: white;
            font-size: 0.875rem;
            font-weight: 600;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }
  }

  .design-expertise {
    padding: 4rem 0;

    .expertise-container {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 4rem;
      align-items: center;
    }

    .expertise-content {
      h4 {
        font-size: 2rem;
        font-weight: 700;
        color: #1a1a1a;
        margin-bottom: 2rem;
      }

      .expertise-list {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 2rem;

        .expertise-category {
          h5 {
            font-size: 1.1rem;
            font-weight: 600;
            color: #3182ce;
            margin-bottom: 1rem;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }

          ul {
            list-style: none;
            padding: 0;

            li {
              display: flex;
              align-items: center;
              gap: 0.75rem;
              margin-bottom: 0.75rem;
              color: #4a5568;
              font-size: 1rem;

              a {
                color: #4a5568;
                text-decoration: none;
                transition: all 0.3s ease;
                display: flex;
                align-items: center;
                gap: 0.75rem;

                &:hover {
                  color: #3182ce;
                }
              }

              svg {
                color: #3182ce;
                flex-shrink: 0;
              }
            }
          }
        }
      }
    }

    .expertise-image {
      position: relative;
      border-radius: 16px;
      overflow: hidden;
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
      height: 400px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.5s ease;
      }

      .image-overlay-card {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(
          to right,
          rgba(0, 100, 200, 0.1),
          transparent
        );
      }

      &:hover img {
        transform: scale(1.05);
      }
    }
  }

  .modular-approach {
    padding: 4rem 0;
    background: #f8fafc;
    border-radius: 24px;
    margin: 4rem 0;

    .modular-container {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 4rem;
      align-items: center;
    }

    .modular-image {
      position: relative;
      border-radius: 16px;
      overflow: hidden;
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
      height: 400px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.5s ease;
      }

      .image-overlay-card {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(
          to right,
          rgba(0, 100, 200, 0.1),
          transparent
        );
      }

      &:hover img {
        transform: scale(1.05);
      }
    }

    .modular-content {
      .content-header {
        display: flex;
        align-items: center;
        gap: 1rem;
        margin-bottom: 1.5rem;

        .icon-wrapper {
          width: 60px;
          height: 60px;
          background: linear-gradient(135deg, #3182ce, #2c5282);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;

          svg {
            color: white;
            font-size: 1.5rem;
          }
        }

        h4 {
          font-size: 1.75rem;
          font-weight: 700;
          color: #1a1a1a;
          line-height: 1.3;
        }
      }

      p {
        font-size: 1.1rem;
        color: #666;
        line-height: 1.6;
        margin-bottom: 2rem;
      }

      .modular-features {
        .feature {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          margin-bottom: 0.75rem;
          color: #4a5568;
          font-size: 1rem;

          svg {
            color: #3182ce;
            flex-shrink: 0;
          }
        }
      }
    }
  }

  .design-manufacturer {
    padding: 4rem 0;

    .manufacturer-container {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 4rem;
      align-items: start;
    }

    .manufacturer-content {
      .content-header {
        display: flex;
        align-items: center;
        gap: 1rem;
        margin-bottom: 1.5rem;

        .icon-wrapper {
          width: 60px;
          height: 60px;
          background: linear-gradient(135deg, #3182ce, #2c5282);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;

          svg {
            color: white;
            font-size: 1.5rem;
          }
        }

        h4 {
          font-size: 1.75rem;
          font-weight: 700;
          color: #1a1a1a;
          line-height: 1.3;
        }
      }

      .manufacturer-description {
        font-size: 1.1rem;
        color: #666;
        line-height: 1.6;
        margin-bottom: 2rem;
      }

      .manufacturer-details {
        p {
          font-size: 1.1rem;
          color: #666;
          line-height: 1.6;
          margin-bottom: 2rem;
        }

        .benefits-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 1.5rem;
          margin-bottom: 2.5rem;

          .benefit-item {
            display: flex;
            align-items: center;
            gap: 0.75rem;
            padding: 1rem;
            background: #f8fafc;
            border-radius: 8px;
            transition: all 0.3s ease;

            &:hover {
              background: #edf2f7;
              transform: translateY(-2px);
            }

            .benefit-icon {
              width: 40px;
              height: 40px;
              background: linear-gradient(135deg, #3182ce, #2c5282);
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-shrink: 0;

              svg {
                color: white;
              }
            }

            span {
              font-size: 1rem;
              font-weight: 500;
              color: #1a1a1a;
            }
          }
        }

        .contact-info {
          background: #f0f9ff;
          border-left: 4px solid #3182ce;
          padding: 1.5rem;
          border-radius: 8px;

          p {
            margin-bottom: 0.75rem;
            font-size: 1rem;
            color: #4a5568;

            strong {
              color: #1a1a1a;
            }

            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }

    .manufacturer-image {
      position: relative;
      border-radius: 16px;
      overflow: hidden;
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
      height: 500px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.5s ease;
      }

      .image-overlay-card {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(
          to right,
          rgba(0, 100, 200, 0.1),
          transparent
        );
      }

      &:hover img {
        transform: scale(1.05);
      }
    }
  }

  .intellectual-property {
    padding: 4rem 0;
    background: #f8fafc;
    border-radius: 24px;
    margin: 4rem 0;

    .intellectual-container {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 4rem;
      align-items: center;
    }

    .intellectual-content {
      .content-header {
        display: flex;
        align-items: center;
        gap: 1rem;
        margin-bottom: 1.5rem;

        .icon-wrapper {
          width: 60px;
          height: 60px;
          background: linear-gradient(135deg, #3182ce, #2c5282);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;

          svg {
            color: white;
            font-size: 1.5rem;
          }
        }

        h4 {
          font-size: 1.75rem;
          font-weight: 700;
          color: #1a1a1a;
          line-height: 1.3;
        }
      }

      .intellectual-description {
        font-size: 1.1rem;
        color: #666;
        line-height: 1.6;
        margin-bottom: 2rem;
      }

      .ip-features {
        .ip-feature {
          display: flex;
          align-items: center;
          gap: 1rem;
          margin-bottom: 1.5rem;
          padding: 1.5rem;
          background: white;
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
          transition: all 0.3s ease;

          &:hover {
            transform: translateY(-4px);
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
          }

          &:last-child {
            margin-bottom: 2rem;
          }

          .ip-icon {
            width: 50px;
            height: 50px;
            background: linear-gradient(135deg, #3182ce, #2c5282);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;

            svg {
              color: white;
              font-size: 1.25rem;
            }
          }

          .ip-text {
            h5 {
              font-size: 1.1rem;
              font-weight: 600;
              color: #1a1a1a;
              margin-bottom: 0.25rem;
            }

            p {
              font-size: 0.95rem;
              color: #666;
              line-height: 1.4;
            }
          }
        }
      }

      .ip-note {
        font-size: 1rem;
        color: #4a5568;
        line-height: 1.6;
        font-style: italic;
        border-left: 3px solid #3182ce;
        padding-left: 1rem;
      }
    }

    .intellectual-image {
      position: relative;
      border-radius: 16px;
      overflow: hidden;
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
      height: 400px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.5s ease;
      }

      .image-overlay-card {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(
          to right,
          rgba(0, 100, 200, 0.1),
          transparent
        );
      }

      &:hover img {
        transform: scale(1.05);
      }
    }
  }

  .cta-section {
    padding: 5rem 0;
    text-align: center;

    .cta-content {
      max-width: 800px;
      margin: 0 auto;

      h3 {
        font-size: 2.5rem;
        font-weight: 700;
        color: #1a1a1a;
        margin-bottom: 1rem;
      }

      p {
        font-size: 1.25rem;
        color: #666;
        line-height: 1.6;
        margin-bottom: 2.5rem;
      }

      .btn-primary {
        display: inline-flex;
        align-items: center;
        gap: 0.75rem;
        background: linear-gradient(135deg, #3182ce 0%, #2c5282 100%);
        color: white;
        border: none;
        padding: 1.25rem 3rem;
        font-size: 1.1rem;
        font-weight: 600;
        border-radius: 50px;
        cursor: pointer;
        transition: all 0.3s ease;
        text-transform: uppercase;
        letter-spacing: 0.5px;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(49, 130, 206, 0.4);

          svg {
            transform: translateX(5px);
          }
        }

        svg {
          transition: transform 0.3s ease;
        }
      }
    }
  }

  /* Media Queries for New Sections */
  @media screen and (min-width: 900px) {
    .prototype-importance,
    .medical-prototype,
    .prototype-development,
    .six-development {
      .prototype-writeUps,
      .medical-prototype-writeUps,
      .prototype-development-writeUps,
      .six-write-ups {
        h4 {
          font-size: 1.75rem;
        }
      }
    }
  }

  @media screen and (max-width: 900px) {
    .prototype-medical {
      padding: 3rem 0;

      h4 {
        font-size: 1.75rem;
      }

      p {
        font-size: 1rem;
      }
    }

    .prototype-importance {
      padding: 3rem 0;
      border-radius: 16px;
      margin: 3rem 0;

      .prototype-writeUps {
        h4 {
          font-size: 1.5rem;
        }

        > p,
        ul li,
        > p:last-of-type {
          font-size: 1rem;
        }
      }

      .prototype {
        height: 300px;
      }
    }

    .medical-prototype {
      padding: 3rem 0;

      .medical-prototype-writeUps {
        h4 {
          font-size: 1.5rem;
        }

        p {
          font-size: 1rem;
        }
      }

      .medical-prototype-image {
        height: 350px;
      }
    }

    .prototype-development {
      padding: 3rem 0;
      border-radius: 16px;
      margin: 3rem 0;

      .prototype-development-image {
        height: 300px;
      }

      .prototype-development-writeUps {
        h4 {
          font-size: 1.5rem;
        }

        p,
        ul li {
          font-size: 1rem;
        }
      }
    }

    .six-development {
      padding: 3rem 0;

      .six-development-image {
        height: 350px;
      }

      .six-write-ups {
        h4 {
          font-size: 1.5rem;
        }

        > p,
        ul li {
          font-size: 1rem;
        }
      }
    }
  }

  @media screen and (max-width: 600px) {
    .prototype-medical {
      padding: 2.5rem 0;

      h4 {
        font-size: 1.5rem;
      }

      p {
        font-size: 0.95rem;
      }
    }

    .prototype-importance {
      padding: 2.5rem 0;

      .prototype-writeUps {
        h4 {
          font-size: 1.25rem;
        }

        > p,
        ul li,
        > p:last-of-type {
          font-size: 0.95rem;
        }
      }

      .prototype {
        height: 250px;
      }
    }

    .medical-prototype {
      padding: 2.5rem 0;

      .medical-prototype-writeUps {
        h4 {
          font-size: 1.25rem;
        }

        p {
          font-size: 0.95rem;
        }
      }

      .medical-prototype-image {
        height: 300px;
      }
    }

    .prototype-development {
      padding: 2.5rem 0;

      .prototype-development-image {
        height: 250px;
      }

      .prototype-development-writeUps {
        h4 {
          font-size: 1.25rem;
        }

        p,
        ul li {
          font-size: 0.95rem;
        }
      }
    }

    .six-development {
      padding: 2.5rem 0;

      .six-development-image {
        height: 300px;
      }

      .six-write-ups {
        h4 {
          font-size: 1.25rem;
        }

        > p,
        ul li {
          font-size: 0.95rem;
        }
      }
    }
  }

  @media screen and (max-width: 420px) {
    .prototype-medical {
      h4 {
        font-size: 1.25rem;
      }

      p {
        font-size: 0.9rem;
      }
    }

    .prototype-importance {
      .prototype-writeUps {
        h4 {
          font-size: 1.1rem;
        }

        > p,
        ul li,
        > p:last-of-type {
          font-size: 0.9rem;
        }
      }

      .prototype {
        height: 200px;
      }
    }

    .medical-prototype {
      .medical-prototype-writeUps {
        h4 {
          font-size: 1.1rem;
        }

        p {
          font-size: 0.9rem;
        }
      }

      .medical-prototype-image {
        height: 250px;
      }
    }

    .prototype-development {
      .prototype-development-image {
        height: 200px;
      }

      .prototype-development-writeUps {
        h4 {
          font-size: 1.1rem;
        }

        p,
        ul li {
          font-size: 0.9rem;
        }
      }
    }

    .six-development {
      .six-development-image {
        height: 250px;
      }

      .six-write-ups {
        h4 {
          font-size: 1.1rem;
        }

        > p,
        ul li {
          font-size: 0.9rem;
        }
      }
    }
  }

  /* Existing Media Queries */
  @media screen and (max-width: 1366px) {
    .contact-hero-section {
      height: 65vh;

      .hero-content {
        h3 {
          font-size: 3.25rem;
        }

        p {
          font-size: 1.2rem;
        }
      }
    }

    .container {
      padding: 0 1.5rem;
    }

    .section-header {
      h3 {
        font-size: 2.25rem;
      }
    }

    .design-expertise,
    .modular-approach,
    .design-manufacturer,
    .intellectual-property {
      .expertise-container,
      .modular-container,
      .manufacturer-container,
      .intellectual-container {
        gap: 3rem;
      }
    }
  }

  @media screen and (max-width: 1200px) {
    .contact-hero-section {
      height: 60vh;

      .hero-content {
        h3 {
          font-size: 3rem;
        }
      }
    }

    .design-expertise {
      .expertise-container {
        .expertise-image {
          height: 350px;
        }
      }
    }

    .modular-approach {
      .modular-container {
        .modular-image {
          height: 350px;
        }
      }
    }

    .design-manufacturer {
      .manufacturer-container {
        .manufacturer-image {
          height: 450px;
        }
      }
    }

    .intellectual-property {
      .intellectual-container {
        .intellectual-image {
          height: 350px;
        }
      }
    }
  }

  @media screen and (max-width: 900px) {
    .contact-hero-section {
      height: 55vh;
      margin-bottom: 3rem;

      .hero-content {
        h3 {
          font-size: 2.5rem;
        }

        p {
          font-size: 1.1rem;
          margin-bottom: 1.5rem;
        }

        .btn-secondary {
          padding: 0.875rem 2rem;
          font-size: 1rem;
        }
      }
    }

    .section-header {
      margin-bottom: 3rem;

      h3 {
        font-size: 2rem;
      }

      .section-subtitle {
        font-size: 1.1rem;
      }

      .section-description {
        font-size: 1rem;
      }
    }

    .design-expertise {
      padding: 3rem 0;

      .expertise-container {
        grid-template-columns: 1fr;
        gap: 3rem;
      }

      .expertise-content {
        h4 {
          font-size: 1.75rem;
        }

        .expertise-list {
          grid-template-columns: 1fr;
          gap: 1.5rem;
        }
      }

      .expertise-image {
        height: 300px;
        order: 2;
      }
    }

    .modular-approach {
      padding: 3rem 0;
      margin: 3rem 0;
      border-radius: 16px;

      .modular-container {
        grid-template-columns: 1fr;
        gap: 3rem;
      }

      .modular-image {
        height: 300px;
        order: 2;
      }

      .modular-content {
        .content-header {
          h4 {
            font-size: 1.5rem;
          }
        }
      }
    }

    .design-manufacturer {
      padding: 3rem 0;

      .manufacturer-container {
        grid-template-columns: 1fr;
        gap: 3rem;
      }

      .manufacturer-content {
        .content-header {
          h4 {
            font-size: 1.5rem;
          }
        }

        .manufacturer-description {
          font-size: 1rem;
        }

        .manufacturer-details {
          .benefits-grid {
            grid-template-columns: 1fr;
          }
        }
      }

      .manufacturer-image {
        height: 350px;
        order: 2;
      }
    }

    .intellectual-property {
      padding: 3rem 0;
      margin: 3rem 0;
      border-radius: 16px;

      .intellectual-container {
        grid-template-columns: 1fr;
        gap: 3rem;
      }

      .intellectual-content {
        .content-header {
          h4 {
            font-size: 1.5rem;
          }
        }

        .intellectual-description {
          font-size: 1rem;
        }
      }

      .intellectual-image {
        height: 300px;
        order: 2;
      }
    }

    .cta-section {
      padding: 4rem 0;

      .cta-content {
        h3 {
          font-size: 2rem;
        }

        p {
          font-size: 1.1rem;
        }

        .btn-primary {
          padding: 1rem 2.5rem;
          font-size: 1rem;
        }
      }
    }
  }

  @media screen and (max-width: 600px) {
    .contact-hero-section {
      height: 100vh;

      .hero-content {
        h3 {
          font-size: 2rem;
          margin-bottom: 1rem;
        }

        p {
          font-size: 1rem;
          margin-bottom: 1.5rem;
        }

        .btn-secondary {
          padding: 0.75rem 1.5rem;
          font-size: 0.9rem;
        }
      }
    }

    .container {
      padding: 0 1rem;
    }

    .section-header {
      margin-bottom: 2.5rem;

      h3 {
        font-size: 1.75rem;
      }

      .section-subtitle {
        font-size: 1rem;
      }

      .section-description {
        font-size: 0.95rem;
      }
    }

    .design-expertise {
      padding: 2.5rem 0;

      .expertise-image {
        height: 250px;
      }

      .expertise-content {
        h4 {
          font-size: 1.5rem;
          margin-bottom: 1.5rem;
        }
      }
    }

    .modular-approach {
      padding: 2.5rem 0;
      margin: 2.5rem 0;

      .modular-image {
        height: 250px;
      }

      .modular-content {
        .content-header {
          flex-direction: column;
          align-items: flex-start;
          gap: 1rem;

          .icon-wrapper {
            width: 50px;
            height: 50px;
          }

          h4 {
            font-size: 1.25rem;
          }
        }

        p {
          font-size: 1rem;
        }
      }
    }

    .design-manufacturer {
      padding: 2.5rem 0;

      .manufacturer-image {
        height: 300px;
      }

      .manufacturer-content {
        .content-header {
          flex-direction: column;
          align-items: flex-start;
          gap: 1rem;

          .icon-wrapper {
            width: 50px;
            height: 50px;
          }

          h4 {
            font-size: 1.25rem;
          }
        }

        .manufacturer-description {
          font-size: 1rem;
        }

        .manufacturer-details {
          .benefits-grid {
            .benefit-item {
              .benefit-icon {
                width: 35px;
                height: 35px;
              }

              span {
                font-size: 0.95rem;
              }
            }
          }

          .contact-info {
            padding: 1rem;
          }
        }
      }
    }

    .intellectual-property {
      padding: 2.5rem 0;
      margin: 2.5rem 0;

      .intellectual-image {
        height: 250px;
      }

      .intellectual-content {
        .content-header {
          flex-direction: column;
          align-items: flex-start;
          gap: 1rem;

          .icon-wrapper {
            width: 50px;
            height: 50px;
          }

          h4 {
            font-size: 1.25rem;
          }
        }

        .intellectual-description {
          font-size: 1rem;
        }

        .ip-features {
          .ip-feature {
            padding: 1rem;

            .ip-icon {
              width: 40px;
              height: 40px;
            }

            .ip-text {
              h5 {
                font-size: 1rem;
              }

              p {
                font-size: 0.9rem;
              }
            }
          }
        }
      }
    }

    .cta-section {
      padding: 3rem 0;

      .cta-content {
        h3 {
          font-size: 1.75rem;
        }

        p {
          font-size: 1rem;
          margin-bottom: 2rem;
        }

        .btn-primary {
          padding: 0.875rem 2rem;
          font-size: 0.95rem;
        }
      }
    }
  }

  @media screen and (max-width: 420px) {
    .contact-hero-section {
      height: 100vh;

      .hero-content {
        h3 {
          font-size: 1.75rem;
        }

        p {
          font-size: 0.9rem;
        }

        .btn-secondary {
          padding: 0.625rem 1.25rem;
          font-size: 0.85rem;
        }
      }
    }

    .section-header {
      h3 {
        font-size: 1.5rem;
      }

      .section-subtitle {
        font-size: 0.9rem;
      }

      .section-description {
        font-size: 0.9rem;
      }
    }

    .design-expertise {
      .expertise-image {
        height: 200px;
      }

      .expertise-content {
        h4 {
          font-size: 1.25rem;
        }
      }
    }

    .modular-approach {
      .modular-image {
        height: 200px;
      }

      .modular-content {
        .content-header {
          h4 {
            font-size: 1.1rem;
          }
        }

        p {
          font-size: 0.95rem;
        }
      }
    }

    .design-manufacturer {
      .manufacturer-image {
        height: 250px;
      }

      .manufacturer-content {
        .content-header {
          h4 {
            font-size: 1.1rem;
          }
        }

        .manufacturer-description {
          font-size: 0.95rem;
        }
      }
    }

    .intellectual-property {
      .intellectual-image {
        height: 200px;
      }

      .intellectual-content {
        .content-header {
          h4 {
            font-size: 1.1rem;
          }
        }

        .intellectual-description {
          font-size: 0.95rem;
        }
      }
    }

    .cta-section {
      .cta-content {
        h3 {
          font-size: 1.5rem;
        }

        p {
          font-size: 0.9rem;
        }

        .btn-primary {
          padding: 0.75rem 1.5rem;
          font-size: 0.9rem;
        }
      }
    }
  }

  @media screen and (max-width: 350px) {
    .contact-hero-section {
      height: 100vh;

      .hero-content {
        h3 {
          font-size: 1.5rem;
        }

        p {
          font-size: 0.85rem;
        }

        .btn-secondary {
          padding: 0.5rem 1rem;
          font-size: 0.8rem;

          svg {
            width: 16px;
            height: 16px;
          }
        }
      }
    }

    .container {
      padding: 0 0.5rem;
    }

    .section-header {
      h3 {
        font-size: 1.25rem;
      }

      .section-subtitle {
        font-size: 0.85rem;
      }

      .section-description {
        font-size: 0.85rem;
      }
    }

    .design-expertise {
      .expertise-image {
        height: 180px;
      }
    }

    .modular-approach {
      .modular-image {
        height: 180px;
      }
    }

    .design-manufacturer {
      .manufacturer-image {
        height: 220px;
      }
    }

    .intellectual-property {
      .intellectual-image {
        height: 180px;
      }
    }

    .cta-section {
      .cta-content {
        h3 {
          font-size: 1.25rem;
        }

        p {
          font-size: 0.85rem;
        }

        .btn-primary {
          padding: 0.625rem 1.25rem;
          font-size: 0.85rem;

          svg {
            width: 16px;
            height: 16px;
          }
        }
      }
    }
  }
`;

export default Design;
